import { render, staticRenderFns } from "./CollectionControls.vue?vue&type=template&id=743ccc1a&scoped=true&"
import script from "./CollectionControls.vue?vue&type=script&lang=js&"
export * from "./CollectionControls.vue?vue&type=script&lang=js&"
import style0 from "./CollectionControls.vue?vue&type=style&index=0&id=743ccc1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743ccc1a",
  null
  
)

export default component.exports